import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=64c675af&fddApi"
import script from "./footer.vue?vue&type=script&lang=js&fddApi"
export * from "./footer.vue?vue&type=script&lang=js&fddApi"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports